import api from "APP_ROOT/api";
import { SUCCESS } from "LIB/submission";
import { USER } from "MODULES/users/constants";
import { ID, UUID } from "APP_ROOT/constants";
import { toastr } from "react-redux-toastr";
import { push } from "react-router-redux";
import * as actionTypes from "./actionTypes";
import { update as updateSession } from "../session/actions";
import { pagination } from "./pagination";

export const { search, setFilter, pageActions } = pagination;

export function searchUsers(filter) {
  return () =>
    api.users
      .search({ filter, active: true, page: 1, limit: 10 })
      .then(resp => Promise.resolve(resp.data.results));
}

export const searchRoleUsers = roles => filter =>
  api.users
    .search({ filter, roles, active: true, page: 1, limit: 10 })
    .then(resp => Promise.resolve(resp.data.results));

export function searchAllUsers(params = {}) {
  return () =>
    api.users.search(params).then(resp => Promise.resolve(resp.data.results));
}

export function create(data) {
  return dispatch =>
    api.users.create(data).then(() => {
      dispatch(pageActions.expire());
      return SUCCESS;
    });
}

export function enableMfa() {
  return (dispatch, getState) => {
    const userId = getState().userDetail.getIn([USER, UUID]);

    return api.users.enableMfa(userId).then(() => {
      toastr.success("Please check your email to enable MFA.");

      return SUCCESS;
    });
  };
}

export function reset(data) {
  return dispatch =>
    api.password
      .reset(data)
      .then(() => {
        toastr.success("Success", "Password Reset.");
        dispatch(push({ pathname: "/login" }));
      })
      .catch(() => {
        toastr.error("Something went wrong.");
      });
}

export function forgot(data) {
  return () =>
    api.password
      .forgot(data.email)
      .then(() => SUCCESS)
      .catch(() => {
        toastr.error("Something went wrong.");
      });
}

export function sendVerificationRequest() {
  return (dispatch, getState) => {
    const userId = getState().userDetail.getIn([USER, UUID]);

    return api.users.requestVerification(userId).then(resp => {
      dispatch({
        type: actionTypes.SET,
        user: resp.data
      });

      return SUCCESS;
    });
  };
}

export function show(id) {
  return dispatch =>
    api.users.show(id).then(resp =>
      dispatch({
        type: actionTypes.SET,
        user: resp.data
      })
    );
}

export function verify(data) {
  return (dispatch, getState) => {
    const userId = getState().userDetail.getIn([USER, UUID]);

    return api.users.verifyEmail(userId, data).then(resp => {
      dispatch({
        type: actionTypes.SET,
        user: resp.data
      });

      return SUCCESS;
    });
  };
}

export function update(data) {
  return (dispatch, getState) => {
    const userId = getState().userDetail.getIn([USER, ID]);
    let payload = { ...data };
    if (data.buying_limit !== undefined) {
      payload = {
        ...data,
        buying_limit: Number(data.buying_limit)
      };
    }
    return api.users.update(userId, payload).then(resp => {
      const currentUser = getState().session.get(USER);
      if (currentUser.get(ID) === userId) {
        dispatch(updateSession(resp.data));
      }

      dispatch({
        type: actionTypes.SET,
        user: resp.data
      });
      dispatch(pageActions.expire());
      return SUCCESS;
    });
  };
}



// WEBPACK FOOTER //
// ./app/modules/users/actions.js